'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var verticalStyles = styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  top: ", ";\n  left: 0;\n  width: ", ";\n  height: ", ";\n  transition: top .5s ease;\n"], ["\n  top: ", ";\n  left: 0;\n  width: ", ";\n  height: ", ";\n  transition: top .5s ease;\n"])), function (_a) {
    var indent = _a.indent;
    return indent + "px";
}, function (_a) {
    var lineWidth = _a.lineWidth;
    return lineWidth + "px";
}, function (_a) {
    var size = _a.size;
    return size + "px";
});
var horizontalStyles = styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  bottom: 0;\n  left: ", ";\n  height: ", ";\n  width: ", ";\n  transition: left .5s ease;\n"], ["\n  bottom: 0;\n  left: ", ";\n  height: ", ";\n  width: ", ";\n  transition: left .5s ease;\n"])), function (_a) {
    var indent = _a.indent;
    return indent + "px";
}, function (_a) {
    var lineWidth = _a.lineWidth;
    return lineWidth + "px";
}, function (_a) {
    var size = _a.size;
    return size + "px";
});
var orientationsStyles = {
    vertical: verticalStyles,
    horizontal: horizontalStyles,
};
var Line = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  ", ";\n"], ["\n  position: absolute;\n  background-color: ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b;
    return orientationsStyles[orientation];
});
var templateObject_1, templateObject_2, templateObject_3;

exports.Line = Line;
